import { backendURL, postRestURL } from "../utils/constants/constants";

export async function getNetworksOfFluincr() {
    try {
        const response = await fetch(`${postRestURL}/informationfluincr?select=socialnetwork`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

/* export async function getYoutubeSubscriber({ channelId }) {

    try {
        const response = await fetch(`${googleApi}/youtube/v3/channels?part=statistics&id=${channelId}&key=${googleKey}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
} */




/* ------------TIKTOK--------------- */
export async function tiktokConect({ typeUser, token }) {
    try {
        const response = await fetch(`${backendURL}/tiktok/authURL/${typeUser}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

export async function validateStateTiktok({ typeUser, token, state }) {
    try {
        const response = await fetch(`${backendURL}/tiktok/validateState/${typeUser}?state=${state}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

export async function getAccessTokenTiktok({ typeUser, token, code }) {
    try {
        const response = await fetch(`${backendURL}/tiktok/access_token/${typeUser}?code=${code}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

export async function getRevokeAccessTokenTiktok({ typeUser, token }) {
    try {
        const response = await fetch(`${backendURL}/tiktok/revoke/${typeUser}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}
/* ------------TWITTER--------------- */
export async function twitterConect({ twitterName, token, typeUser }) {
    try {
        const response = await fetch(`${backendURL}/twitter/by/username/${typeUser}/${twitterName}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

export async function getRevokeAccessTokenTwitter({ typeUser, token }) {
    try {
        const response = await fetch(`${backendURL}/twitter/revoke/${typeUser}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

/* ------------YOUTUBE--------------- */
export async function youtubeConect({ typeUser, token }) {
    try {
        const response = await fetch(`${backendURL}/youtube/authURL/${typeUser}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

export async function validateStateYoutube({ typeUser, token, state }) {
    try {
        const response = await fetch(`${backendURL}/youtube/validateState/${typeUser}?state=${state}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

export async function getAccessTokenYoutube({ typeUser, token, code }) {
    try {
        const response = await fetch(`${backendURL}/youtube/access_token/${typeUser}?code=${code}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

export async function getRevokeAccessTokenYoutube({ typeUser, token }) {
    try {
        const response = await fetch(`${backendURL}/youtube/revoke/${typeUser}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

/**--------------FACEBOOK----------------- */
export async function getAccessFacebook({ token, facebookToken, facebookId }) {

    try {
        const response = await fetch(`${backendURL}/facebook/authFacebook/influencer?short_tfb=${facebookToken}&id_user=${facebookId}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

export async function getRevokeAccessTokenFacebook({ typeUser, token }) {
    try {
        const response = await fetch(`${backendURL}/facebook/revoke/${typeUser}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

/**--------------INSTAGRAM----------------- */
export async function getAccessInstagram({ token, userType, instagramCode }) {

    try {
        const response = await fetch(`${backendURL}/instagram/authInstagram/${userType}?code=${instagramCode}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

export async function getAccessFacebookInstagram({ token, userType, facebookToken, facebookId }) {
    try {
        const response = await fetch(`${backendURL}/instagram/authInstagramFacebook/${userType}?short_tfb=${facebookToken}&id_user_facebook=${facebookId}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

export async function getRevokeAccessTokenInstagram({ typeUser, token }) {
    try {
        const response = await fetch(`${backendURL}/instagram/revoke/${typeUser}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch {

    }
}

/**-----------My networks------------ */
export async function getMyFollowersNetworks({ userId, typeUser }) {
    try {
        const response = await fetch(`${postRestURL}/${typeUser}?select=followers&id=eq.${userId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}